import { ProcessRouteStepInput } from "gql/graphql";

/**
 * Есть ли в собранных значениях формы шаг без персоны и без роли.
 *
 * Такой шаг получается из шага со скрытым участником: тип шага восстанавливается из
 * значения, у скрытой персоны значения нет, поле с `required` не монтируется и валидация
 * шаг пропускает. Сохранение стёрло бы участника из маршрута, поэтому это последняя
 * проверка перед мутацией — там, где кнопка сохранения живёт в отдельной форме и
 * `disabled` до неё не доходит.
 */
export function routeHasIncompleteSteps(
  route: Pick<ProcessRouteStepInput, "person" | "role">[],
): boolean {
  return route.some((step) => !step.person && !step.role);
}
